(() => {
  if (customElements.get("bestseller-badge")) return;

  // Share requests across cards, including cards replaced by AJAX filtering.
  const rankings = new Map();
  const cacheLifetime = 5 * 60 * 1000;
  const requestTimeout = 8000;
  async function getRanking(collectionUrl) {
    const url = new URL(collectionUrl, window.location.origin);
    if (url.origin !== window.location.origin) {
      throw new Error("Ranking must use the storefront origin");
    }
    url.search = "";
    url.hash = "";
    url.searchParams.set("view", "bestseller-ranking");
    url.searchParams.set("sort_by", "best-selling");
    url.searchParams.set("page", "1");
    const previewTheme = new URLSearchParams(window.location.search).get(
      "preview_theme_id",
    );
    if (previewTheme) url.searchParams.set("preview_theme_id", previewTheme);
    const key = url.href;
    const cached = rankings.get(key);
    if (!cached || Date.now() - cached.createdAt >= cacheLifetime) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), requestTimeout);
      const request = fetch(key, {
        credentials: "same-origin",
        signal: controller.signal,
      })
        .then((response) => {
          if (!response.ok) throw new Error("Ranking request failed");
          return response.json();
        })
        .then((ranking) => {
          if (
            ranking.sort !== "best-selling" ||
            typeof ranking.title !== "string" ||
            !Array.isArray(ranking.products) ||
            ranking.products.length > 3 ||
            !ranking.products.every(
              (id) => typeof id === "string" && /^\d+$/.test(id),
            ) ||
            new Set(ranking.products).size !== ranking.products.length
          )
            throw new Error("Invalid ranking response");
          return ranking;
        })
        // Cache failures briefly to avoid repeated requests during filter changes.
        .catch(() => {
          const entry = rankings.get(key);
          if (entry?.promise === request) {
            entry.createdAt = Date.now() - cacheLifetime + 30000;
          }
          return null;
        })
        .finally(() => clearTimeout(timeout));
      rankings.set(key, { promise: request, createdAt: Date.now() });
    }
    return rankings.get(key).promise;
  }

  customElements.define(
    "bestseller-badge",
    class extends HTMLElement {
      connectedCallback() {
        const requestId = (this.requestId || 0) + 1;
        this.requestId = requestId;
        this.hidden = true;
        getRanking(this.dataset.collectionUrl)
          .then((ranking) => {
            if (!ranking || !this.isConnected || this.requestId !== requestId)
              return;
            const rank = ranking.products.indexOf(this.dataset.productId) + 1;
            if (!rank) return;
            const label = document.createElement("strong");
            label.className = "bestseller-badge__rank";
            label.textContent = `#${rank} ${this.dataset.label || "BESTSELLER"}`;
            this.replaceChildren(label);
            const category = document.createElement("span");
            category.className = "bestseller-badge__category";
            category.textContent = ` ${this.dataset.categoryPrefix || "in"} ${ranking.title}`;
            this.append(category);
            this.hidden = false;
          })
          // Leave badges hidden if rankings cannot be loaded; never guess ranks.
          .catch(() => {});
      }

      disconnectedCallback() {
        this.requestId = (this.requestId || 0) + 1;
      }
    },
  );
})();
